import React, { useEffect, useState } from "react";
import { supabase } from "../../Services/supabaseClient";
import { useCompany } from "../../context/CompanyContext";
import { useNavigate } from "react-router-dom";
import "./packs.css";

export default function FinancialPacks() {
  const { companyId } = useCompany();
  const navigate = useNavigate();

  const [packs, setPacks] = useState([]);
  const [tone, setTone] = useState("standard");
  const [includeModules, setIncludeModules] = useState({
    auditor: true,
    value_added: false,
    tax: false,
  });

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const today = new Date().toISOString().slice(0, 10);
    const y = new Date().getFullYear();
    setStartDate(`${y}-01-01`);
    setEndDate(today);
  }, []);

  useEffect(() => {
    if (!companyId) return;
    load();
    // eslint-disable-next-line
  }, [companyId]);

  const load = async () => {
    setLoading(true);
    const { data, error } = await supabase
      .from("fs_packs")
      .select("id,title,status,start_date,end_date,created_at")
      .eq("company_id", companyId)
      .order("created_at", { ascending: false });
    setLoading(false);

    if (error) return alert(error.message);
    setPacks(data || []);
  };

  const createPack = async () => {
    if (!companyId) return alert("No company selected.");
    if (!startDate || !endDate) return alert("Pick start and end dates.");

    setLoading(true);
    const { data, error } = await supabase.rpc("rpc_create_fs_pack_v3", {
      p_company_id: companyId,
      p_start_date: startDate,
      p_end_date: endDate,
      p_include_modules: includeModules,
      p_tone: tone,
    });
    setLoading(false);

    if (error) return alert(error.message);
    navigate(`/packs/${data}`);
  };

  return (
    <div className="pack-wrap">
      <div className="pack-header">
        <div>
          <h2>Audit-Format Financials Pack</h2>
          <p>
            Create, edit page-by-page, approve, and export a full audit-style
            pack.
          </p>
        </div>
        <button className="btn" onClick={load} disabled={loading}>
          Refresh
        </button>
      </div>

      <div className="card">
        <h3>Create a new pack</h3>

        <div className="grid2">
          <div className="row">
            <label>Start Date</label>
            <input
              className="input"
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
            />
          </div>

          <div className="row">
            <label>End Date</label>
            <input
              className="input"
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
            />
          </div>
        </div>

        <div className="grid2">
          <div className="row">
            <label>Tone</label>
            <select value={tone} onChange={(e) => setTone(e.target.value)}>
              <option value="formal">Formal</option>
              <option value="standard">Standard</option>
              <option value="concise">Concise</option>
            </select>
          </div>

          <div className="row">
            <label>Modules</label>
            <div className="checks">
              <label>
                <input
                  type="checkbox"
                  checked={includeModules.auditor}
                  onChange={(e) =>
                    setIncludeModules((s) => ({
                      ...s,
                      auditor: e.target.checked,
                    }))
                  }
                />
                Auditor’s Report
              </label>

              <label>
                <input
                  type="checkbox"
                  checked={includeModules.value_added}
                  onChange={(e) =>
                    setIncludeModules((s) => ({
                      ...s,
                      value_added: e.target.checked,
                    }))
                  }
                />
                Value Added
              </label>

              <label>
                <input
                  type="checkbox"
                  checked={includeModules.tax}
                  onChange={(e) =>
                    setIncludeModules((s) => ({ ...s, tax: e.target.checked }))
                  }
                />
                Tax Computation
              </label>
            </div>
          </div>
        </div>

        <button className="btn primary" onClick={createPack} disabled={loading}>
          {loading ? "Working..." : "Generate Pack"}
        </button>
      </div>

      <div className="card">
        <h3>Existing packs</h3>

        {packs.length === 0 ? (
          <p className="muted">No packs created yet.</p>
        ) : (
          <div className="list">
            {packs.map((p) => (
              <div
                key={p.id}
                className="list-item"
                onClick={() => navigate(`/packs/${p.id}`)}
              >
                <div>
                  <div className="title">{p.title}</div>
                  <div className="meta">
                    {p.status} • {p.start_date} → {p.end_date} •{" "}
                    {new Date(p.created_at).toLocaleString()}
                  </div>
                </div>
                <div className="link">Open →</div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
